module.exports = __webpack_public_path__ + "static/img/7en.9cf0c81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/7en.png
// module id = RPLa
// module chunks = 0